export const
    csProject = {
        path: "/safetyCheck/cstProject",
        component: require("@/components/pages/safetyCheck/cstProject/main.vue"),
        children: [{ //施工安全考评（登记）
                path: "/safetyCheck/cstProject/seasonCheckRegist",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/seasonCheckRegist.vue"], resolve),
                meta: { componentName: "seasonCheckRegist" }
            }, { //项目月考评（搜索）
                path: "/safetyCheck/cstProject/monthCheckQuery",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/monthCheckQuery.vue"], resolve),
                meta: { componentName: "monthCheckQuery" }
            }, { //项目月考评（登记）
                path: "/safetyCheck/cstProject/monthCheckRegist",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/monthCheckRegist.vue"], resolve),
                meta: { componentName: "monthCheckRegist" }
            }, { //项目月考评（签章）
                path: "/safetyCheck/cstProject/monthCheckSign",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/monthCheckSign.vue"], resolve),
                meta: { componentName: "monthCheckSign" }
            }, { //项目竣工考评（搜索）
                path: "/safetyCheck/cstProject/doneCheckQuery",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/doneCheckQuery.vue"], resolve),
                meta: { componentName: "seasonCheckRegist" }
            }, { //项目竣工考评（签章）
                path: "/safetyCheck/cstProject/doneCheckSign",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/doneCheckSign.vue"], resolve),
                meta: { componentName: "seasonCheckRegist" }
            }, { //项目竣工考评（填报）
                path: "/safetyCheck/cstProject/doneCheckRegist",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/doneCheckRegist.vue"], resolve),
                meta: { componentName: "doneCheckRegist" }
            }, { //竣工考评结果公示书
                path: "/safetyCheck/cstProject/doneResultPublicity",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/doneResultPublicity.vue"], resolve),
                meta: { componentName: "doneResultPublicity" }
            }, { //竣工考评结果告知书
                path: "/safetyCheck/cstProject/doneResultInform",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/doneResultInform.vue"], resolve),
                meta: { componentName: "doneResultInform" }
            }, { //项目考评异议核实（搜索）
                path: "/safetyCheck/cstProject/objectionCheckQuery",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/objectionCheckQuery.vue"], resolve),
                meta: { componentName: "objectionCheckQuery" }
            }, { //项目考评异议复核（搜索）
                path: "/safetyCheck/cstProject/objectionRecheckQuery",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/objectionRecheckQuery.vue"], resolve),
                meta: { componentName: "objectionRecheckQuery" }
            }, { //撤销项目考评结果（搜索）
                path: "/safetyCheck/cstProject/revokeCheckResQuery",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/revokeCheckResQuery.vue"], resolve),
                meta: { componentName: "revokeCheckResQuery" }
            }, { //撤销项目考评结果公式书
                path: "/safetyCheck/cstProject/revokeCheckResPublicity",
                component: resolve => require(["../components/pages/safetyCheck/cstProject/revokeCheckResPublicity.vue"], resolve),
                meta: { componentName: "revokeCheckResPublicity" }
            }

        ]
    }


// WEBPACK FOOTER //
// ./src/router/csProject.js